/** Max SVG price Lines (gutter + plot share this list). */
export const MAX_PRICE_LINES = 20;

const ALL_SKU_DIMS = {
  variety: true,
  size: true,
  grade: true,
  storage: true,
  condition: true,
  environment: true,
  quality: true,
  appearance: true,
  properties: true,
};

/** dims: boolean package flag (legacy) or { variety, size, ... package }. All-true default. */
export function comboSuffix(item, dimsOrPackage = ALL_SKU_DIMS) {
  const dims = dimsOrPackage === true || dimsOrPackage === false
    ? { ...ALL_SKU_DIMS, package: dimsOrPackage }
    : (dimsOrPackage || ALL_SKU_DIMS);
  const parts = [];
  if (dims.variety) parts.push(item?.variety || '');
  if (dims.size) parts.push(item?.item_size || item?.size || '');
  if (dims.grade) parts.push(item?.grade || '');
  if (dims.storage) parts.push(item?.storage || '');
  if (dims.condition) parts.push(item?.condition || '');
  if (dims.environment) parts.push(item?.environment || '');
  if (dims.quality) parts.push(item?.quality || '');
  if (dims.appearance) parts.push(item?.appearance || '');
  if (dims.properties) parts.push(item?.properties || '');
  if (dims.package) parts.push(item?.package || item?.sku || '');
  if (!parts.length) return '';
  return `::${parts.join('::')}`;
}

/** Unique color per full combo lineKey. No palette cap. */
export function pulseLineColor(lineKey) {
  const s = String(lineKey || '');
  let h = 2166136261;
  for (let i = 0; i < s.length; i += 1) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  const u = h >>> 0;
  const hue = u % 360;
  const sat = 58 + (u % 20);
  const lit = 38 + ((u >>> 10) % 16);
  return `hsl(${hue} ${sat}% ${lit}%)`;
}

export function districtFromLineKey(lineKey) {
  const head = String(lineKey || '').split('::')[0];
  const lowLoc = head.lastIndexOf('_low_price');
  if (lowLoc !== -1) return head.slice(0, lowLoc);
  const highLoc = head.lastIndexOf('_high_price');
  if (highLoc !== -1) return head.slice(0, highLoc);
  return head;
}

function pairId(lineKey) {
  return String(lineKey).replace('_low_price', '_price').replace('_high_price', '_price');
}

/** Round-robin per origin. Keep Low+High of the same combo together. */
export function capLineKeys(keys, max = MAX_PRICE_LINES) {
  const list = Array.from(keys);
  if (list.length <= max) return { keys: list, total: list.length, capped: false };
  const pairMap = new Map();
  for (const k of list) {
    const id = pairId(k);
    let p = pairMap.get(id);
    if (!p) {
      p = [];
      pairMap.set(id, p);
    }
    p.push(k);
  }
  const buckets = [];
  const index = new Map();
  for (const pair of pairMap.values()) {
    const d = districtFromLineKey(pair[0]);
    let b = index.get(d);
    if (!b) {
      b = [];
      index.set(d, b);
      buckets.push(b);
    }
    b.push(pair);
  }
  const out = [];
  let i = 0;
  while (out.length < max) {
    let added = false;
    for (const b of buckets) {
      if (i < b.length) {
        const pair = b[i];
        if (out.length + pair.length > max) continue;
        out.push(...pair);
        added = true;
        if (out.length >= max) break;
      }
    }
    if (!added) break;
    i += 1;
  }
  return { keys: out, total: list.length, capped: true };
}

export function varyingExtraIndexes(lineKeys) {
  const extras = (lineKeys || []).map((k) => String(k).split('::').slice(1));
  const n = extras.reduce((m, e) => Math.max(m, e.length), 0);
  const vary = [];
  for (let i = 0; i < n; i += 1) {
    const set = new Set(extras.map((e) => e[i] || ''));
    vary[i] = set.size > 1;
  }
  return vary;
}
